import { EVENT_TYPES, TypeIdSchema } from '@unipile/db';
import { Type, type Static } from '@sinclair/typebox';
import { StringEnum } from '../../utils/typebox';

export const WEBHOOK_CONVERSATION_STATUSES = ['success', 'failed'] as const;

export const WebhookConversationStatusSchema = StringEnum([...WEBHOOK_CONVERSATION_STATUSES], {
  description:
    'The delivery status of an event, based on its latest delivery attempt to the endpoint. `success` means the endpoint returned a 2xx HTTP status; `failed` means it returned another status or did not respond.',
});

export const ListWebhookConversationsQuerySchema = Type.Object({
  endpoint_id: TypeIdSchema('webhookEndpoint', {
    description: 'Filter to return only conversations for the given endpoint.',
  }),
  event_id: Type.Optional(TypeIdSchema('event', { description: 'Filter to return only conversations for the given event.' })),
  account_id: Type.Optional(
    TypeIdSchema('account', { description: 'Filter to return only conversations for events from the given account.' }),
  ),
  event_type: Type.Optional(
    StringEnum([...EVENT_TYPES], { description: 'Filter to return only conversations for events of the given type.' }),
  ),
  status: Type.Optional(WebhookConversationStatusSchema),
  created_after: Type.Optional(
    Type.String({
      format: 'date-time',
      description: 'Filter to return only conversations created at or after the given date and time, in ISO 8601 format.',
    }),
  ),
  created_before: Type.Optional(
    Type.String({
      format: 'date-time',
      description: 'Filter to return only conversations created before the given date and time, in ISO 8601 format.',
    }),
  ),
  offset: Type.Optional(Type.String({ description: 'An offset used for pagination.' })),
  limit: Type.Optional(Type.String({ description: 'A limit used for pagination.' })),
});

export const ListWebhookConversationAccountsQuerySchema = Type.Object({
  endpoint_id: TypeIdSchema('webhookEndpoint', {
    description: 'Return only accounts whose events were delivered to the given endpoint.',
  }),
});

export type WebhookConversationStatus = Static<typeof WebhookConversationStatusSchema>;
export type ListWebhookConversationsQuery = Static<typeof ListWebhookConversationsQuerySchema>;
export type ListWebhookConversationAccountsQuery = Static<typeof ListWebhookConversationAccountsQuerySchema>;
